export default __webpack_public_path__ + "static/media/gamepad.403191c8.svg";